import React, { useState } from 'react';
import ProjectModal from './ProjectModal';

const projects = [
  { 
    id: 1, 
    title: 'Coumba Kandji Diamonds', 
    category: 'Luxury Brand Identity', 
    description: 'Development of a luxury brand identity, packaging system and visual communication assets for a diamond sourcing and investment company based in West Africa. Over the course of the project, I was responsible for shaping the overall visual direction of the brand, including luxury packaging concepts, investor and partnership presentations, social media assets and brand collateral across multiple touchpoints. The challenge was to translate a trust-based business model into a refined and structured visual system that communicates exclusivity, transparency and long-term value while maintaining consistency across physical and digital applications.', 
    year: '2024', 
    thumbnail: 'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/srjnhm7g_198.jpg', 
    images: [
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/srjnhm7g_198.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/0c1vpycb_ckd.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/t5j2xhjx_Firefly_Gemini%20Flash_use%20the%20exact%20setting%20and%20picture%20of%20the%20packaging%20design%20and%20make%20the%20logo%20in%20glossy%20194570.png',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/a642l898_PORTFOLIO_JANAJANKE_26-2.png'
    ] 
  },
  { 
    id: 2, 
    title: 'Kelevra Fashion', 
    category: 'Fashion Brand Development', 
    description: 'Long-term brand development for a Ibiza based fashion label across digital, print and product touchpoints. Starting with web design and digital foundations, the project evolved into a complete visual identity including branding, apparel graphics, packaging inserts, product labels and printed brand materials. I developed cohesive design assets across multiple collections and ensured a consistent brand experience throughout digital and physical customer touchpoints.', 
    year: '2024', 
    thumbnail: 'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/u6emx2yp_kelevra1pic.png', 
    images: [
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/u6emx2yp_kelevra1pic.png',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/4bwdcig4_kelevra-branding.png',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/o04z1p5e_klvr_poster_l1.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/qz6fxj75_kelevra-web.png'
    ] 
  },
  { 
    id: 3, 
    title: 'Oceanbeat Boatparty', 
    category: 'Event Branding', 
    description: 'Long-Term support of creative campaign and promotional design for one of Ibiza\'s best-known event brands. Responsible for flyer campaigns, brochure layouts, promotional print materials and merchandise design across multiple seasons. The work focused on high-impact visual communication for both digital and physical event marketing environments while maintaining brand consistency across a wide range of formats.', 
    year: '2024', 
    thumbnail: 'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/h43p7eu2_landscape-books_oceanbeat.png', 
    images: [
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/h43p7eu2_landscape-books_oceanbeat.png',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/zdzd89jo_logo_oceanbeat.png',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/ex96fu27_klappw%C3%BCrfel_oceanbeat.jpg'
    ] 
  },
  { 
    id: 4, 
    title: 'Ibiza Advertising', 
    category: 'Outdoor Advertising', 
    description: 'Billboard designs for large-scale outdoor advertising in high-visibility event environments. The focus was on creating bold, eye-catching visuals that remain clear and impactful from a distance, while staying consistent with the brand identity. The designs were developed to communicate quickly and effectively in fast-paced, real-world settings.', 
    year: '2024', 
    thumbnail: 'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/t2snx5ej_billboard_swag.jpg', 
    images: [
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/t2snx5ej_billboard_swag.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/virdivt8_P79UN61.jpg', 
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/zasbhufs_P79URM1.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/tm0e1d49_6095525.jpg'
    ] 
  },
  { 
    id: 5, 
    title: 'Soul2Soul', 
    category: 'Event Branding', 
    description: 'Long-term visual design support for a premium urban music brand operating across Germany, Spain and Dubai. Developed over 200 campaign visuals, print assets, promotional materials and branded merchandise while maintaining consistency across high-volume creative output. The project required efficient adaptation of visual systems across multiple formats and campaigns while keeping the brand visually fresh and engaging.', 
    year: '2023-2024', 
    thumbnail: 'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/me3z9rq6_s2sflyercollage.jpg', 
    images: [
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/me3z9rq6_s2sflyercollage.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/0k7i83cb_Flyer%20Hanging_S2S%20Ibiza%20barcelonass.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/11a3j1rq_Flyer%20Hanging_S2S%20Ibiza%20barcelonaxcx.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/bdqlq2kn_s2smerchendise.png'
    ] 
  },
  { 
    id: 6, 
    title: 'Kimamba Juice', 
    category: 'Packaging Design', 
    description: 'Packaging and product branding concept inspired by West African culture and flavors. Developed the brand identity, packaging design system, product labels and visual storytelling for a beverage concept designed to achieve strong shelf presence and brand recognition. The project focused on combining vibrant visual identity with commercially effective packaging design principles.', 
    year: '2024', 
    thumbnail: 'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/nfk0d04x_bissapjuicemock.jpg', 
    images: [
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/nfk0d04x_bissapjuicemock.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/trnc9i1v_bissapjuiceposter.jpg',
      'https://customer-assets.emergentagent.com/job_jana-graphics/artifacts/kufy7uou_gingerjuice.jpg'
    ] 
  },
  { 
    id: 7, 
    title: 'Deputy Department', 
    category: 'CRM, Email Marketing & Digital Retention', 
    description: 'Development of a comprehensive email marketing framework, retention strategy, and digital conversion assets for a modern heavyweight streetwear brand. Over the course of the project, I was responsible for designing and structuring the brand\'s digital customer journey across key conversion and retention touchpoints. This included high-converting email newsletter templates, strategic A/B testing concepts for lead-capture pop-ups balancing immediate discount incentives against exclusive early access, and an automated post-purchase CRM flow designed to maximize Customer Lifetime Value. The challenge was to bridge performance-driven e-commerce mechanics with a distinct editorial streetwear aesthetic—creating a seamless visual system that drives cross-selling, customer loyalty, and continuous engagement without compromising brand integrity.', 
    year: '2024', 
    thumbnail: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/mf9w8mse_newsletterdesign.png', 
    images: [
      'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/mf9w8mse_newsletterdesign.png',
      'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/61zlye75_postpurchase.png',
      'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/48y00i10_abtest.png'
    ] 
  },
  { 
    id: 8, 
    title: 'Quantum Leap Fitness', 
    category: 'Performance Ads & Social Campaigns', 
    description: 'Conceptualization and design of high-converting performance ads, social media campaigns, and promotional email banners for a premium fitness and nutrition brand. Over the course of the project, I was responsible for crafting dynamic visual assets tailored for paid social and digital acquisition channels. This involved developing performance-driven ad creatives across Instagram Posts and Stories, combining bold typography with high-impact product renders to clearly communicate value propositions such as low-calorie, high-protein benefits under tight timelines. Additionally, I designed promotional email campaign banners engineered to boost conversion rates and drive sales during promotional launches. The objective was to blend aggressive e-commerce performance marketing triggers with a clean, high-end visual aesthetic that builds brand authority and maximizes campaign ROI.', 
    year: '2024', 
    thumbnail: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/i2c67vo3_socialmediaads.webp', 
    images: [
      'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/i2c67vo3_socialmediaads.webp',
      'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/6e99a20i_QLF_emailbanner.webp'
    ] 
  },
  { 
    id: 9, 
    title: '3D Asset Design & Visual Explorations', 
    category: '3D Modeling & Brand Assets', 
    description: 'Creation of custom 3D assets, branded props, and atmospheric key visuals using Cinema 4D. Developed for various brands and event labels—including recurring visual assets for Soul2Soul—this showcase highlights my ongoing work in spatial modeling, detailed texturing, and realistic studio lighting to build iconic, high-quality brand touchpoints.', 
    year: '2024', 
    thumbnail: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/ptvnjkp0_spraycans-done.png', 
    sliders: [
      {
        title: 'Soul2Soul Spray Cans',
        before: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/tytwe1vm_spraycans-raw.png',
        after: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/ptvnjkp0_spraycans-done.png'
      },
      {
        title: 'Soul2Soul Ibiza Medallion',
        before: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/b14ykih2_s2sibiza-raw.png',
        after: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/s452k62h_s2sibiza-done.png'
      },
      {
        title: 'Turntable Design',
        before: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/krp8db60_turntable-raw.png',
        after: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/598w7csz_turntable-done.png'
      },
      {
        title: 'Soul2Soul Winter Scene',
        before: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/0hm0dk2z_s2sheaven-raw.png',
        after: 'https://customer-assets-rejwkqb3.emergentagent.net/job_jana-graphics/artifacts/ivh8jjm8_s2sheaven.png'
      }
    ]
  }
];

const ProjectGrid = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <>
      <section className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="mb-24">
            <h2 className="text-5xl md:text-6xl font-bold mb-4" style={{ fontFamily: 'Archivo, sans-serif' }}>SELECTED WORK</h2>
            <div className="w-24 h-px bg-black mt-4"></div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {projects.map((project, index) => (
              <div key={project.id} className="group cursor-pointer relative overflow-hidden bg-white aspect-square" onClick={() => setSelectedProject(project)}>
                <div className="absolute inset-0 overflow-hidden">
                  <img 
                    src={project.thumbnail} 
                    alt={project.title} 
                    loading="lazy"
                    className="w-full h-full object-cover grayscale transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105" 
                  />
                  <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>
                </div>
                <div className="absolute inset-0 p-8 flex flex-col justify-end bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <p className="text-xs tracking-widest text-white mb-2" style={{ fontFamily: 'Archivo, sans-serif' }}>{project.category}</p>
                  <h3 className="text-2xl font-bold text-white" style={{ fontFamily: 'Archivo, sans-serif' }}>{project.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {selectedProject && <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />}
    </>
  );
};

export default ProjectGrid;